import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { canAccessCms } from './index';

// handle the public routes for CMS
function CmsPublicRoute({ component: Component, ...rest }) {
    const allowed = canAccessCms();
    return (
        <Route
            {...rest}
            render={(props) =>
                !allowed ? <Component {...props} /> : <Redirect to={{ pathname: '/cms/dashboard' }} />
            }
        />
    )
}

export default CmsPublicRoute;
